import { AdminPermission } from '../commons/Me';

export class GlobalPermissions {
    private static _adminsPerms: AdminPermission[] = [];
    public static initializeGlobalPermissions = (perms: Array<AdminPermission> = []) => {
        GlobalPermissions._adminsPerms = perms;
    };
}
